<template>
  <div class="livechat">
    <livechat-mw class="livechat__main-window"></livechat-mw>
  </div>
</template>

<script>

export default {
}
</script>

<style lang="scss">
.livechat {
  padding: 10px;
  &__main-window {
    width: 100%;
    height: 100%;
  }
}
</style>
